<p-confirmDialog key="export" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="OptionSize">
	<div class="SubMenu">
		<h4>Students:</h4>

		<div class="GridMenu">
			<label>School:</label>
			<caass-schoolselector [Disabled]="IsLoading() == true" [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
			</caass-schoolselector>

			<label>Staff Type:</label>
			<p-dropdown
				[disabled]="IsLoading() == true"
				[options]="lstPersonType"
				[(ngModel)]="SelectedPersonType"
				optionLabel="PersonTypeDesc"
				[filter]="true"
				filterBy="PersonTypeDesc"
				[showClear]="false"
				placeholder="Select a Staff Type"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="SelectedPersonType">
						<div class="form-control NoBorder" style="text-align: left">
							{{ SelectedPersonType.PersonTypeDesc }}
						</div>
					</div>
				</ng-template>
				<ng-template let-PersonTypeItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ PersonTypeItem.PersonTypeDesc }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<label>Teaches Course:</label>
			<p-dropdown
				[disabled]="IsLoading() == true"
				[options]="lstCourse"
				[(ngModel)]="SelectedCourse"
				optionLabel="CourseDesc"
				[filter]="true"
				filterBy="CourseDesc"
				[showClear]="false"
				placeholder="Select a Course"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="SelectedCourse">
						<div class="form-control NoBorder" style="text-align: left">
							{{ SelectedCourse.CourseDesc }}
						</div>
					</div>
				</ng-template>
				<ng-template let-CourseItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ CourseItem.CourseDesc }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<label>Active:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOptionID" [(ngModel)]="ActiveOptionID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>

			<label>Already Printed:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="AlreadyPrintedID" [(ngModel)]="AlreadyPrintedID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstAlreadyPrinted" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>

			<label>Has Email:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="HasEmailOptionID" [(ngModel)]="HasEmailOptionID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstHasEmailOption" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>

	<div class="SubMenu TopMargin">
		<h4>Format:</h4>

		<div class="GridMenu">
			<label>Format:</label>
			<select [disabled]="IsLoading() == true" class="form-control" name="SelectedFormatOption" [(ngModel)]="SelectedFormatOption">
				<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
					{{ o.Desc }}
				</option>
			</select>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onExport()">Export</button>
	<button [disabled]="IsProcessing == true" class="btn btn-warning" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
